<!-- ProjectDetailModal.vue -->
<template>
  <v-navigation-drawer
    v-model="epa"
    right
    temporary
    fixed
    :width="drawerWidth"
    app
  >
    <v-card elevation="0" style="padding: 15px">
      <v-card-title class="d-flex align-center">
        <div class="text-h4 font-weight-medium">
          {{ project.name || "Cargando…" }}
        </div>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate />
        </div>
        <div v-else>
          <div class="mb-4" style="font-size: 1.2em">
            <strong>Dirección:</strong> {{ project.address }}
          </div>
          <div class="mb-4" style="font-size: 1.2em">
            <strong>Presupuesto:</strong> {{ project.budget | currency }}
          </div>
          <div class="mb-4" style="font-size: 1.2em">
            <strong>Inicio:</strong> {{ project.start_date }}
          </div>
          <div class="mb-4" style="font-size: 1.2em">
            <strong>Tipo:</strong> {{ project.type.name }}
          </div>
          <div class="mb-4" style="font-size: 1.2em">
            <strong>Fase:</strong> {{ project.phase.name }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import ProjectService from "@/services/ProjectService";

export default {
  name: "ProjectDetailView",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    projectId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      project: {},
      loading: false,
      epa: true,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    drawerWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? "100%" : "40%";
    },
  },
  watch: {
    projectId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchProject(id);
      },
    },
  },
  methods: {
    async fetchProject(id) {
      this.loading = true;
      try {
        const res = await ProjectService.getById(id);
        if (res.ok) {
          const project = await res.json();
          this.project = project;
        }
      } catch (e) {
        console.error("Error cargando proyecto", e);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.show = false;
      this.$router.push({ name: "projects" });
    },
  },
  filters: {
    currency(value) {
      if (value == null) return "—";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(value);
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  /* Asegura que el drawer esté por encima */
  z-index: 2000;
}
</style>
